/**
 * CertModeChip — Phase 4 (2026-07-27).
 *
 * Small persistent chip pinned to the top-right of the app header
 * while Hotelbeds certification isolation mode is active. Navy
 * background, white text, tiny — deliberately subtle so it doesn't
 * read as an error banner during cert review.
 *
 * Rendered by AppShell — no direct placement required from pages.
 */
import React from "react";
import { ShieldCheck } from "lucide-react";
import { useCertMode } from "@/hooks/useCertMode";

export default function CertModeChip() {
  const { active } = useCertMode();
  if (!active) return null;
  return (
    <span
      data-testid="cert-mode-chip"
      title="Hotelbeds certification isolation mode is active — non-Hotelbeds affiliate widgets are hidden."
      className="inline-flex items-center gap-1 rounded-full bg-tb-navy-deep text-white border border-white/40 px-2 py-0.5 text-[10px] font-hand uppercase tracking-widest whitespace-nowrap"
      style={{ letterSpacing: "0.12em" }}
    >
      <ShieldCheck className="w-3 h-3" strokeWidth={2.2} />
      Cert · Hotelbeds
    </span>
  );
}
